import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getIsAuth } from '@/entities/Auth';
import { useGetUnreadNotificationsCountQuery } from '@/entities/Notifications';
import { routerPath } from '@/shared/config/router';
import { LocalStorageService } from '@/shared/services/localStorage.service';
import { Svg } from '@/shared/ui/Svg';
import NotificationIcon from '@/shared/assets/icons/notification-icon.svg';
import styles from './NotificationLink.module.scss';

export const NotificationLink = () => {
  const isAuth = useSelector(getIsAuth);
  const accessToken = LocalStorageService.getAccessTokenFromAnyStorage();

  const { data } = useGetUnreadNotificationsCountQuery(undefined, {
    skip: !isAuth && !accessToken,
  });

  const unreadCount = data?.count ?? 0;

  return (
    <Link
      to={routerPath.pushNotifications}
      className={styles.root}
      aria-label={
        unreadCount > 0 ? `Push notifications, ${unreadCount} unread` : 'Push notifications'
      }
    >
      <Svg Icon={NotificationIcon} width={48} height={48} />
      {unreadCount > 0 ? (
        <span className={styles.badge} aria-hidden>
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      ) : null}
    </Link>
  );
};
